import styled from "styled-components";

export const SalesInfoSection = styled.section`
  background-color: #ffffff;
  margin-bottom : 8px;
  .show-all-flowers-btn {
    width: 100%;
    border-radius: 8px;
    border: 1px solid #cfd4d9;
    padding: 12px 0;
    background-color: #ffffff;
    color: #4a5056;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    margin-top: 18px;
  }
`;

export const SalesInfoHeader = styled.div`
  padding: 24px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .fresh-flower-title,
  .fresh-flower-count {
    font-weight: 700;
    font-size: 16px;
  }

  .fresh-flower-count {
    color: #ff7a00;
  }

  .arrow-right {
    color: black;
    cursor: pointer;
  }
`;

export const TodaySalesFlowerList = styled.ul`
  padding: 0 16px 24px 16px;

  .container {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    background-color: #ffffff !important;
  }

  li {
    margin-right: 8px;
    cursor: pointer;

    p {
      font-weight: 400;
      font-size: 16px;
    }

    img {
      width: 136px;
      height: 136px;
      border-radius: 8px;
    }
  }

  .more-info {
    > div {
      position: relative;

      img {
        background-color: black;
        filter: brightness(0.3);
      }

      p {
        position: absolute;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
        font-weight: 700;
        font-size: 18px;
        color: #ffffff;
      }
    }
  }
`;

export const LastMonthSalesFlowerList = styled.ul`
  padding: 0 16px 24px 16px;
  display: grid;
  grid-template-rows: repeat(3, 104px, 128px;);
  grid-template-columns: repeat(3, 1fr);
  gap: 16px 8px;

  img {
    width: 104px;
    height: 104px;
    border-radius: 8px;
  }

  li {
    margin: 0 auto;
    p {
      font-weight: 400;
      font-size: 14px;
    }
  }
`;

export const Divider = styled.span`
  display: block;
  width: 100%;
  height: 1px;
  background-color: #f1f3f5;
`;
